import _ from 'lodash';
import {all} from 'redux-saga/effects';

import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  fetchAgreementUser as fetchAgreementUserAction,
  updateAgreementUser as updateAgreementUserAction,
  verifyAgreementUserInternalAvatarUpload as verifyAgreementUserInternalAvatarUploadAction
} from './';

import {
  fetchAgreementUser,
  updateAgreementUser,
  verifyAgreementUserInternalAvatarUpload
} from 'sdk/agreementUsers';

function* agreementUsersSaga() {
  yield all([
    createFetchSagaLatest(fetchAgreementUserAction, fetchAgreementUser),
    createPostSagaLatest(updateAgreementUserAction, updateAgreementUser),
    createPostSagaLatest(
      verifyAgreementUserInternalAvatarUploadAction,
      verifyAgreementUserInternalAvatarUpload
    )
  ]);
}

export default agreementUsersSaga;
